wbApp.directive('wbCzMsMtListUniversalCombo', ['$timeout', '$translate', 'czMsMtRegistrySvc', 'gridSortSvc',
    function ($timeout, $translate, czMsMtRegistrySvc, gridSortSvc) {
        function format(item) {
            if (item.id) return item.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
              ngModel: '=',
              listName: '=',
              multiSelect: '=',
              specification: '=',  
            },
            link: function (scope, elm, attrs, controller) {
                
                let allLists = czMsMtRegistrySvc.lists();
                let list = [];
                allLists.$promise.then(function() {
                    list.length = 0;
                    list.push.apply(list, allLists[scope.listName]);
                    if (scope.specification !== undefined) {
                        let filteredList = _.filter(allLists[scope.listName], function(item) {
                            return item.specification === scope.specification;
                        });
                        list.length = 0;
                        list.push.apply(list, filteredList);
                    }
                    
                    $timeout(function () {
                        $(elm).select2({
                            placeholder: 'Nevyplněno',
                            formatResult: format,
                            formatSelection: format,
                            dropdownAutoWidth: true,
                            allowClear: true,
                            minimumResultsForSearch: 5,
                            id: function (model) {
                                return model.id;
                            },
                            data: list,
                            matcher: function (term, text, data) {
                                return data.name.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                            },
                            multiple: scope.multiSelect || false,
                            maximumSelectionSize: 5
                        });

                        controller.$render = function () {
                            if (allLists.$promise) {
                                allLists.$promise.then(function() {
                                    elm.select2('val', controller.$viewValue);
                                });
                            }
                        };

                        if (scope.multiSelect) {
                            controller.$parsers.unshift(function (viewValue) {
                                if (Array.isArray(viewValue)) {
                                    if (viewValue.length === 0) {
                                        return null;
                                    } 
                                    return viewValue.join(",");
                                }
                            });

                            controller.$formatters.unshift(function (value) {
                                if (!value) {
                                    return null;
                                }
                                return _.map(value.split(','), function (n) {
                                    return n + '';
                                }).join(",");
                            });
                        }
                        scope.$watch('specification', function (newValue) {
                            if (newValue !== undefined) {
                                if (newValue === '999xxx') {
                                    newValue = 'C99xxx';
                                }
                                if (!!newValue) {
                                    let filteredList = _.filter(allLists[scope.listName], function (item) {
                                        return item.specification === newValue;
                                    });

                                    filteredList = _.sortBy(filteredList, function (a) {
                                        return gridSortSvc.localeSort(a, 'name');
                                    });
                                    
                                    list.length = 0;
                                    list.push.apply(list, filteredList);
                                } else {
                                    let filteredList = allLists[scope.listName];
                                    filteredList = _.sortBy(filteredList, function (a) {
                                        return gridSortSvc.localeSort(a, 'name');
                                    });
                                    list.length = 0;
                                    list.push.apply(list, filteredList);
                                }
                                
                                $(elm).select2('data', list);
                                
                                if (list.length === 0) {
                                    $(elm).select2('val', null);
                                    controller.$setViewValue(null);
                                } else {
                                    let selectedValue = controller.$viewValue;
                                    console.info('selectedValue: ' + controller.$viewValue);
                                    if (!_.find(list, { 'id': selectedValue })) {

                                        console.info('not found');
                                        
                                        $(elm).select2('val', list[0].id);
                                        controller.$setViewValue(list[0].id);
                                    } else {
                                        $(elm).select2('val', selectedValue);
                                        controller.$setViewValue(selectedValue);
                                    }                                      
                                }
                            } 
                        });
        
                        elm.on('change', function () {
                            scope.$apply(function () {
                                controller.$setViewValue(elm.select2('val'));
                            });
                        });
        
                        attrs.$observe('disabled', function (value) {
                            elm.select2('enable', !value);
                        });
        
                        attrs.$observe('readonly', function (value) {
                            elm.select2('readonly', !!value);
                        });
        
                        elm.bind("$destroy", function () {
                            elm.select2("destroy");
                        });
                    }, 1);
                });
            }
        }
    }]);